import { Injectable } from '@angular/core'
import { TicketPackageEntity } from 'libs/gb-front/item/data-access/src/lib/+state/items.models'
import { BehaviorSubject, Observable } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class GbRaffleItemHelperService {
  selectedRafflePackageSubject$: BehaviorSubject<TicketPackageEntity | undefined> = new BehaviorSubject<
    TicketPackageEntity | undefined
  >(undefined)
  selectedRafflePackage$: Observable<TicketPackageEntity | undefined> =
    this.selectedRafflePackageSubject$.asObservable()
}
